import { render, staticRenderFns } from "./BatchInitializeNeCfg.vue?vue&type=template&id=284ecaa3&"
import script from "./BatchInitializeNeCfg.vue?vue&type=script&lang=js&"
export * from "./BatchInitializeNeCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports